<div #mainDiv_model_portfolio_switch>

  <!-- Horizontal line: 20px below the tab row -->
  <div *ngIf="bundle.showTab"
       [style.top.px]="-4"
       [style.left.px]="-3"
       [style.width.px]="bundle.remainingW - 20"
       style="position: absolute; z-index: 99; border-bottom: 2px solid rgb(198, 195, 195); box-sizing: border-box;">
  </div>

  <!-- horzTabs_ll_companys_sp  TABS ACROSS THE TOP-->
  <div *ngIf="bundle.showTab"
       [style.top.px]="0"
       [style.left.px]="bundle.remainingX"
       [style.width.px]="bundle.remainingW"
       [style.height.px]="30"
       style="position:absolute; z-index:100; box-sizing:border-box;">

    <div *ngFor="let item of bundle.horzTabs; let i = index"
         style="float:left; white-space:nowrap; cursor:pointer;"
         (click)="selectTab(item.lbl)">

      <!-- Active tab -->
      <div *ngIf="item.lbl === bundle.activeHorzTab"
           class="wordBtn14_selected"
           style="float:left; padding:10px; box-sizing:border-box;">
        {{ item.lbl }}
      </div>

      <!-- Inactive tab -->
      <div *ngIf="item.lbl !== bundle.activeHorzTab"
           class="wordBtn14"
           style="float:left; padding:10px; box-sizing:border-box;">
        {{ item.lbl }}
      </div>

    </div>


  </div>

  <!-- ll-contact-info-->
  <div *ngIf="bundle.showRemaining"
       [style.top.px]="bundle.remainingY"
       [style.left.px]="bundle.remainingX"
       [style.width.px]="bundle.remainingW"
       [style.height.px]="bundle.remainingH"
       style="position: absolute; z-index: 100">


    <ll-admin-generic-dg *ngIf="bundle.activeHorzTab == 'Most Recent BBCs'" id="ll_model_portfolio_bbc"></ll-admin-generic-dg>
    <ll-admin-generic-dg *ngIf="bundle.activeHorzTab == 'Class-Availability'" id="ll_model_portfolio_classes"></ll-admin-generic-dg>
    <ll-admin-generic-dg *ngIf="bundle.activeHorzTab == 'Class-Liquidity Pct'" id="ll_model_portfolio_classes_pctPay"></ll-admin-generic-dg>
    <ll-admin-generic-dg *ngIf="bundle.activeHorzTab == 'Class-AR Mix'" id="ll_model_portfolio_classes_mix"></ll-admin-generic-dg>
  </div>




</div>

